import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Logo width={50} height={50} showText={false} />
            <h3 style={{ marginTop: '1rem' }}>FluxCore Technology</h3>
            <p className="tagline">Transforming Business at the Speed of Tech</p>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/fluxcore-technology-471a363ab/" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://wa.me/27613923760" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp />
              </a>
              <a href="mailto:info@fluxcoretechnology.co.za" aria-label="Email">
                <FaEnvelope />
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services" state={{ scrollTo: 'application-design' }}>Application Design</Link></li>
              <li><Link to="/services" state={{ scrollTo: 'cloud-solutions' }}>Cloud Solutions</Link></li>
              <li><Link to="/services" state={{ scrollTo: 'automation' }}>Automation</Link></li>
              <li><Link to="/services" state={{ scrollTo: 'ai-integration' }}>AI Integration</Link></li>
              <li><Link to="/services" state={{ scrollTo: 'data-analytics' }}>Data Analytics</Link></li>
              <li><Link to="/services" state={{ scrollTo: 'integrations' }}>Integrations</Link></li>
              <li><Link to="/services" state={{ scrollTo: 'enablement' }}>Enablement</Link></li>
              <li><Link to="/services" state={{ scrollTo: 'consulting' }}>Consulting</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li><a href="mailto:info@fluxcoretechnology.co.za">info@fluxcoretechnology.co.za</a></li>
              <li>
                <a href="https://wa.me/27613923760" target="_blank" rel="noopener noreferrer">
                  +2761 392 3760
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; FluxCore Technology. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
